import $ from 'jquery';
import {UiUtils} from "../utils/ui-utils";
import EmblaCarousel from "embla-carousel";

class MainNav {
    $navPromoBar = $('#nav-promo-bar');
    $mainNav = $('#main-nav');
    $mainNavMobile = $('#main-nav-mobile');
    promoBarExists = false;
    promoBarIsVisible = this.promoBarExists;
    dropDownIsOpen = false;
    $dropdownMenuContainer = $("#main-nav-dropdown-menu");
    submenuIsOpen = false;
    intentTime = 500; //The time that the user has to come back to the menu before autoclosing
    dropDownIsOpening = false;
    isHoveringDesktopNav = false; // prevents nav from hiding while user is hovering over it or the dropdown
    navBarOffset = 177;
    currentActiveSubmenu = null;
    promoBarHeightOnDesktop = 68;
    desktopNavHideThreshold = 68; // px from top before the desktop nav begins hiding on scroll down — tweak this to adjust sensitivity
    desktopNavShowThreshold = 68;  // px of upward scroll required before the nav reappears — tweak this to adjust sensitivity
    navHiddenAtScrollY = null;     // scroll position when the nav was last hidden, used to measure upward scroll distance
    mouseOutTimeout = null;
    scrollPosOnOpen = 0;

    init() {
        this.promoBarExists = document.getElementById('nav-promo-bar') !== null;
        this.addEventListeners();
        this.initPromoBar();

        if(UiUtils.isMobile()){
            this.initCarousel();
            this.initSearchCarousel();
        }
    }

    initPromoBar(){
        let prevScrollpos = window.pageYOffset;
        const that = this;

        if(prevScrollpos === 0){
            that.showPromoBar();
        }

        window.onscroll = function() {
            const currentScrollPos = window.pageYOffset;
            const scrollingUp = prevScrollpos > currentScrollPos;

            if(!UiUtils.isMobile() && that.dropDownIsOpen && Math.abs(currentScrollPos - that.scrollPosOnOpen) > 100) {
                that.closeMenu();
            }

            // Desktop nav: hide when scrolling down past the threshold, show after scrolling up enough
            if (!UiUtils.isMobile()) {
                const scrolledUpEnough = that.navHiddenAtScrollY !== null && (that.navHiddenAtScrollY - currentScrollPos) >= that.desktopNavShowThreshold;
                if (scrolledUpEnough || currentScrollPos < that.desktopNavHideThreshold) {
                    that.$mainNav.removeClass('nav-hidden');
                    that.navHiddenAtScrollY = null;
                } else if (!scrollingUp && !that.dropDownIsOpen && !that.isHoveringDesktopNav) {
                    that.$mainNav.addClass('nav-hidden');
                    that.navHiddenAtScrollY = currentScrollPos; // always track the lowest point so show threshold is relative to it
                }
            }

            if(that.promoBarExists){
                // Only show promo bar offset on nav when the promo bar is actually visible (near top of page)
                if (currentScrollPos < that.promoBarHeightOnDesktop && !that.dropDownIsOpen) {
                    that.showPromoBar();
                } else {
                    if(!that.$dropdownMenuContainer.hasClass('open')){
                        that.hidePromoBar();
                    }
                }

                // Preventing that the promo bar appears when scrolling on top with the menu open (if the promo bar was not already visible) because this causes the menu to move down and break the top margin
                if(!UiUtils.isMobile()){
                    if(currentScrollPos <= that.promoBarHeightOnDesktop
                        && that.$dropdownMenuContainer.hasClass('open')
                        && !that.promoBarIsVisible
                    ){
                        that.showPromoBar();
                    }
                }
            }

            prevScrollpos = currentScrollPos;
        }
    }

    initCarousel(){
        // Init the carousels in the global nav
        const navCardsCarousels = document.getElementsByClassName('js-nav-cards-carousel');
        for(let i = 0; i < navCardsCarousels.length; i++){
            EmblaCarousel(navCardsCarousels[i], { loop: false });
        }
    }

    showPromoBar(){
        if(this.promoBarExists) {
            this.$navPromoBar.addClass('nav-scroll-visible');
            this.$mainNav.addClass('promo-bar-visible');
            this.$mainNavMobile.addClass('promo-bar-visible');
            this.$dropdownMenuContainer.addClass('promo-bar-visible');
            this.$navPromoBar.removeClass('nav-scroll-hidden');
            this.promoBarIsVisible = true;
        }
    }

    hidePromoBar(){
        if(this.promoBarExists){
            this.$navPromoBar.removeClass('nav-scroll-visible');
            this.$navPromoBar.addClass('nav-scroll-hidden');
            this.$mainNav.removeClass('promo-bar-visible');
            this.$dropdownMenuContainer.removeClass('promo-bar-visible');
            this.$mainNavMobile.removeClass('promo-bar-visible');
            this.promoBarIsVisible = false;
        }
    }

    showSearchNav(){
        // Close mobile dropdown
        // Open search nav
    }

    replaceMobileNavOpenButtonWithClose(){
        $('.main-nav-mobile--hamburger-icon')
            .removeClass('open')
            .addClass('close');
    }

    replaceMobileNavCloseButtonWithOpen(){
        $('.main-nav-mobile--hamburger-icon')
            .removeClass('close')
            .addClass('open');
    }

    openDropdownMenu() {
        if(UiUtils.isMobile()){
            this.replaceMobileNavCloseButtonWithOpen();
            this.showPromoBar()
            this.freezeBodyOnMobile();
        } else {
            this.$mainNav.removeClass('nav-hidden'); // ensure nav is visible when dropdown opens
            const navHeight = this.$mainNav[0] ? this.$mainNav[0].offsetHeight : 0;
            $('<div id="main-nav-spacer">').css('height', navHeight + 'px').insertAfter(this.$mainNav);
        }
        this.$dropdownMenuContainer
            .addClass('open')
            .removeClass('closed')
            // .removeClass('slideRight');
        this.$mainNav.addClass('open');
        this.dropDownIsOpen = true;
        this.dropDownIsOpening = false;
    }

    closeDropdownMenu(delayRemoveOpenClass = false) {
        if(UiUtils.isMobile()){
            this.replaceMobileNavOpenButtonWithClose();
            this.unfreezeBodyOnMobile();
        } else {
            $('#main-nav-spacer').remove();
        }
        this.dropDownIsOpening = false;
        this.$dropdownMenuContainer.removeClass('open');
        this.$dropdownMenuContainer.addClass('closed');
        this.submenuIsOpen = false;
        if(delayRemoveOpenClass){
            this.$mainNav.addClass('closing');
            setTimeout(() => this.$mainNav.removeClass('closing'), 300);
        }
        this.$mainNav.removeClass('open');
        // Remove keyup.escnav event listener no needed anymore
        $(document).unbind('keyup.escnav');

        this.dropDownIsOpen = false;
    }

    addEventListeners() {
        if(UiUtils.isMobile()){
            this.listenToMobileHamburgerClick();
            this.listenToMobileFirstLevelMenuItemsClick();
            this.listenToMobileBackButton();
            this.listenToSearchButtonMobile();
        }
        else {
            this.listenToFirstLevelMenuClick();
            this.listenToMouseMoveOnNavAndMenu();
            this.listenToSearchButtonDesktop();
            // this.listenToMouseEnterBobFace();
            // this.listenToDesktopSearchClickOutside();
        }
    }

    closeAllOpenSubmenus() {
        $('.js-main-nav-dropdown-menu-submenu-container')
            .removeClass('open')
            // .removeClass('open-right')
            .addClass('closed');
    }

    resetChevrons() {
        $('.js-main-nav-first-level-link').removeClass('active');
        $('.js-main-nav-first-level-link .js-nav-chevron').removeClass('rotate-180');
    }

    showMobileFirstLevel(){
        $('.main-nav-dropdown-menu--mobile-first-level')
            .removeClass('closed')
            .addClass('open');
    }

    hideMobileFirstLevel(){
        $('.main-nav-dropdown-menu--mobile-first-level')
            .removeClass('open')
            .addClass('closed');
    }

    openSecondLevelMenu(submenuName){
        const $activeSubmenu = $('#submenu-' + submenuName);
        let openClass = 'open';

        if(UiUtils.isMobile() && submenuName !== 'search') {
            openClass = 'open';
        }

      $activeSubmenu
            .addClass(openClass)
            .removeClass('closed');

        this.submenuIsOpen = true;
        this.currentActiveSubmenu = submenuName;
        return $activeSubmenu
    }

    listenToMobileHamburgerClick() {
        const that = this;
        $('#mobile-nav-hamburger-button').on('click', function(){
            if(that.dropDownIsOpen){
                setTimeout(() => that.closeAllOpenSubmenus(), 300);
                that.closeDropdownMenu();
                that.hideMobileFirstLevel();
            }
            else {
                that.openDropdownMenu();
                that.showMobileFirstLevel();
            }
        });
    }

    listenToMobileFirstLevelMenuItemsClick(){
        const that = this;
        $('.js-main-nav-mobile--first-level-link').on('click', function(e){
            e.preventDefault();
            e.stopImmediatePropagation();

            const $this = $(this);
            const submenu = $this.data('submenu');

            that.closeAllOpenSubmenus();
            that.openSecondLevelMenu(submenu);
            that.hideMobileFirstLevel();
        });
    }

    listenToMobileBackButton(){
        const that = this;
        $('.js-main-nav-dropdown-menu-back-button').on('click', function(e){
            that.closeAllOpenSubmenus();
            that.submenuIsOpen = false;
            that.showMobileFirstLevel();
        });
    }

    openMenu(submenu){
        this.dropDownIsOpening = true;
        this.closeDropdownMenu();
        this.closeAllOpenSubmenus();
        const that = this;
        const $activeSubmenu = this.openSecondLevelMenu(submenu);

        if(submenu === 'where-to-buy'){
          // Focus on the where to buy input field
          $('#main-nav-where-to-buy-input').focus();
        }

        if(!UiUtils.isMobile()){
            this.scrollPosOnOpen = window.pageYOffset;
            const amount = ($activeSubmenu.height() + this.navBarOffset) + 'px';
            this.$dropdownMenuContainer.css({'height': amount});
            const $submenuContainer = $activeSubmenu.children();
            // Setting the max scrollable area height so that on smaller devices if the dropdown menu is taller than the screen size, it will enable scrolling
            const mainNavHeight = this.$mainNav[0].clientHeight;
            const promoBarHeight = this.promoBarIsVisible ? this.$navPromoBar[0].clientHeight : 0;
            const scrollableAreaHeight = $(window).height() - (mainNavHeight + promoBarHeight);
            $submenuContainer.css('max-height', scrollableAreaHeight + 'px');
            // add listener for the esc button
            $(document).on('keyup.escnav', function(e){
              if (e.key === "Escape") { // escape key maps to keycode `27`
                that.closeMenu();
              }
            })
        }
        this.openDropdownMenu();
    }

    listenToFirstLevelMenuClick(){
        const that = this;

        $('.js-main-nav-first-level-link').on('click', function(e){
            const submenu = $(this).data('submenu');

            // Items without a submenu or "where-to-buy" just navigate normally
            if(!submenu || submenu === 'where-to-buy'){
                return; // let the <a> tag navigate
            }

            e.preventDefault(); // prevent <a> navigation — open dropdown instead

            // If clicking the same item that's already open, close the menu
            if(that.dropDownIsOpen && that.currentActiveSubmenu === submenu){
                that.closeMenu();
                return;
            }

            that.resetChevrons();
            $(this).addClass('active').find('.js-nav-chevron').addClass('rotate-180');
            that.openMenu(submenu);
        });
    }

    closeMenu(){
        this.currentActiveSubmenu = null;
        this.closeDropdownMenu(!UiUtils.isMobile());
        this.closeAllOpenSubmenus();
        this.resetChevrons();
        // if(!UiUtils.isMobile()){
            // this.$dropdownMenuContainer.css({"max-height": "0px"});
            // this.$dropdownMenuContainer.css({"top": "0px"});
        // }
    }

    // We're using a timeout to give some time to the user to come back to the open menu in case the intention wasn't to close the menu
    listenToMouseMoveOnNavAndMenu() {
        const that = this;

        this.$dropdownMenuContainer.on('mouseleave', function(){
            that.isHoveringDesktopNav = false;
            if(that.submenuIsOpen && that.currentActiveSubmenu !== 'search'){
                // When the user moves the mouse out of the menu we're giving some time to come back without closing it immediately
                that.mouseOutTimeout = setTimeout(function(){
                    // that.closeMenu();
                    that.currentActiveSubmenu = null;
                    that.closeDropdownMenu(true);
                    setTimeout(() => that.closeAllOpenSubmenus(), 300);
                    that.resetChevrons();
                    that.mouseOutTimeout = null;
                }, that.intentTime)
            }
        })

        this.$dropdownMenuContainer.on('mouseenter', function(){
            that.isHoveringDesktopNav = true;
            clearTimeout(that.mouseOutTimeout);
            that.mouseOutTimeout = null;
        })

        // Track hover on the nav bar itself so scroll-hide is suppressed while hovering
        this.$mainNav.on('mouseenter', function(){
            that.isHoveringDesktopNav = true;
            clearTimeout(that.mouseOutTimeout);
            that.mouseOutTimeout = null;
        })

        this.$mainNav.on('mouseleave', function(){
            that.isHoveringDesktopNav = false;
        })
    }

    listenToSearchButtonDesktop(){
        const that = this;

        $('#desktop-search-button').on('click', function(){
            if($('#submenu-search').hasClass('open')){
                that.closeMenu();
            }
            else {
                that.openMenu('search');
                $('#globalsearch').focus();
            }
        });
    }

    listenToDesktopSearchClickOutside(){
        const that = this;
        /*$('.js-close-desktop-search-nav').on('click', function(e) {
            that.closeMenu();
        })*/
    }

    listenToSearchButtonMobile(){
        const that = this;

        $('#mobile-nav-search-button').on('click', function(){
            // that.openMenu('search');
            if($('#submenu-search').hasClass('open')){
                that.closeDropdownMenu();
                that.closeAllOpenSubmenus();
                that.dropDownIsOpening = false;
                that.currentActiveSubmenu = null;
                that.submenuIsOpen = false;
            }
            else {
                that.dropDownIsOpening = true;
                that.closeDropdownMenu();
                that.closeAllOpenSubmenus();
                const activeSubmenu = that.openSecondLevelMenu('search');
                that.openDropdownMenu();
            }
        });
    }

    listenToMouseEnterBobFace(){
        const that = this;
        const desktopLogo = document.querySelector('.js-desktop-nav-logo');
        desktopLogo.addEventListener('mousemove', function(e){
            var rect = e.target.getBoundingClientRect();
            var x = e.clientX - rect.left;
            var y = rect.bottom - e.clientY;
            if(e.target.nodeName === 'IMG' && (x < 40) && (y > 10) && (y < 65)){
                if(!that.mouseOutTimeout){
                    that.mouseOutTimeout = setTimeout(function(){
                        that.closeMenu();
                        // We are resetting the previous overed item because the menu has been closed, and we need to reset this value
                        that.mouseOutTimeout = null;
                    }, that.intentTime);
                }
            }
            else {
                clearTimeout(that.mouseOutTimeout);
                that.mouseOutTimeout = null;
            }
        })
    }

    initSearchCarousel() {
        const searchNavCarousel = document.querySelector('.js-search-nav-carousel');
        const cardsCount = document.querySelectorAll('.js-nav-search-card').length;
        const startIndex = cardsCount > 2 ? Math.floor(cardsCount / 2) : 0;
        // const startIndex = 1;
        const emblaApi = EmblaCarousel(searchNavCarousel, { loop: true, startIndex: startIndex });
    }

    freezeBodyOnMobile() {
        $(document.body).addClass('freezeOnMobile');
    }

    unfreezeBodyOnMobile() {
        $(document.body).removeClass('freezeOnMobile');
    }
}

export {MainNav};
